import { alpha, Theme } from '@mui/material';

// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.text.primary, 0.8),
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
